<template>
  <v-card tile height="100vh">
    <v-row class="fill-height ma-0 pa-0" align="center" justify="center">
      <v-col>
        <div class="kassino-header mb-5">
          <h1 class="text-center mt-5">Comentário Premiado</h1>
          <h4 class="text-center mb-5">Ganhe prêmios especiais, boa sorte!</h4>
        </div>
        <div class="pa-5 slot-box">
          <div class="slot-machine">
            <v-row>
              <v-col v-for="(slot, i) in slots" :key="i" cols="4">
                <div class="slot" ref="slots">
                  <h2>{{ slot.title }}</h2>
                  <div class="slot__window" :style="'height:' + width + 'px;'">
                    <div class="slot__wrap">
                      <div
                        class="slot__item"
                        v-for="(opt, j) in slot.items"
                        :key="j"
                      >
                        <img
                          :src="
                            `https://comenta.ai/assets/tint.php?hex=${color}&image=` +
                              opt
                          "
                          width="100%"
                          height="100%"
                        />
                      </div>
                      <div class="slot__item slot__item--copy">
                        <img
                          :src="
                            `https://comenta.ai/assets/tint.php?hex=${color}&image=` +
                              slot.items[0]
                          "
                          width="100%"
                          height="100%"
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </v-col>
            </v-row>
          </div>
          <v-btn
            color="primary"
            @click="start"
            block
            depressed
            x-large
            class="mt-5"
            rounded
            >SORTEAR!</v-btn
          >
        </div>
        <div class="kassino-footer"></div> </v-col
    ></v-row>

    <v-dialog v-model="winner" persistent>
      <template>
        <v-card class="pa-5 text-center">
          <h3 v-if="this.good" class="mb-5">Parabéns você venceu!</h3>
          <h2 class="mb-5">
            <b>{{ text }}</b>
          </h2>

          <p class="mb-5" v-if="this.good">
            {{ label.mensagem_fale_com_o_atendente }}
          </p>
          <div
            class="py-5 text-center finalcode my-5"
            :style="`border: 2px solid #${color}; color:  #${color};`"
            v-if="this.good"
          >
            {{ code }}
          </div>
          <p class="mb-5" v-if="this.good">
            {{ label.mensagem_enviamos_por_email }}
          </p>
          <p class="mb-5" v-if="!this.good">
            {{ label.mensagem_tente_novamente }}
          </p>

          <v-btn rounded large color="primary" depressed @click="end()" block>
            Beleza!
          </v-btn>
        </v-card>
      </template>
    </v-dialog>
  </v-card>
</template>

<script>
import axios from "axios";

const next =
  window.requestAnimationFrame ||
  window.webkitRequestAnimationFrame ||
  window.mozRequestAnimationFrame ||
  window.msRequestAnimationFrame ||
  window.oRequestAnimationFrame ||
  function(cb) {
    window.setTimeout(cb, 1000 / 60);
  };

export default {
  name: "Roleta",
  props: {
    bhash: String,
    label: Object,
  },
  data: () => ({
    slots: [
      {
        items: [
          "01-preenchido.png",
          "02-preenchido.png",
          "03-preenchido.png",
          "04-preenchido.png",
          "05-preenchido.png",
        ],
      },
      {
        items: [
          "01-preenchido.png",
          "02-preenchido.png",
          "03-preenchido.png",
          "04-preenchido.png",
          "05-preenchido.png",
        ],
      },
      {
        items: [
          "01-preenchido.png",
          "02-preenchido.png",
          "03-preenchido.png",
          "04-preenchido.png",
          "05-preenchido.png",
        ],
      },
    ],
    opts: null,
    startedAt: null,
    resultado: [],
    final: false,
    winner: false,
    choice: [],
    text: "",
    good: false,
    time: 6000,
    delay: 1200,
    code: "",
  }),
  watch: {
    final() {
      if (this.final) {
        this.checkResult();
      }
    },
  },
  computed: {
    width() {
      return Math.floor((document.body.clientWidth - 68) / 3 - 10);
    },
    hash() {
      if (this.bhash) {
        this.updateChoice();
      }
      return this.bhash;
    },
    color() {
      return this.$vuetify.theme.themes.light.primary.split("#")[1];
    },
  },
  methods: {
    start() {
      this.updateChoice();
      if (this.opts) {
        return;
      }

      let resultado = [];
      this.final = false;
      this.opts = this.slots.map((data, i) => {
        const slot = this.$refs.slots[i];
        const choice = this.choice[i]; //  4 //
        resultado[i] = data.items[choice];
        const opts = {
          el: slot.querySelector(".slot__wrap"),
          // finalPos: choice * 180,
          // height: data.items.length * 160,
          // startOffset: 2000 + Math.random() * 500 + i * 500,
          finalPos: choice * this.width,
          startOffset: this.width * 10, // * Math.random(), // * (this.width * 5) + i * (this.width * 5),
          height: data.items.length * this.width,
          duration: this.time + i * this.delay, // milliseconds
          isFinished: false,
          resultado: resultado,
        };
        return opts;
      });

      this.resultado = this.opts[0].resultado;

      next(this.animate);
    },

    animate(timestamp) {
      if (this.startedAt == null) {
        this.startedAt = timestamp;
      }

      const timeDiff = timestamp - this.startedAt;

      this.opts.forEach((opt) => {
        if (opt.isFinished) {
          return;
        }

        const timeRemaining = Math.max(opt.duration - timeDiff, 0);
        const power = 3;
        const offset = Math.floor(
          (Math.pow(timeRemaining, power) / Math.pow(opt.duration, power)) *
            opt.startOffset
        );

        // negative, such that slots move from top to bottom
        const pos = -1 * Math.floor((offset + opt.finalPos) % opt.height);

        opt.el.style.transform = "translateY(" + pos + "px)";

        if (timeDiff > opt.duration) {
          opt.isFinished = true;
        }
      });

      if (this.opts.every((o) => o.isFinished)) {
        this.opts = null;
        this.startedAt = null;
        this.final = true;
      } else {
        next(this.animate);
      }
    },

    checkResult() {
      this.winner = false;
      if (
        this.resultado[0] === this.resultado[1] &&
        this.resultado[0] === this.resultado[2] &&
        this.resultado[0] === "05-preenchido.png"
      ) {
        const url = `https://comenta.ai/evaluate/getReward/${this.bhash}`;
        axios
          .post(url)
          .then((res) => {
            if (res.data.success) {
              this.text = res.data.title;
              this.winner = true;
              this.good = true;
              this.code = res.data.code;
            } else {
              this.text = "Que pena! Não foi dessa vez :/";
              this.winner = true;
              this.good = false;
            }
          })
          .catch((err) => {
            console.log(err);
          });
      } else {
        this.text = "Que pena não foi dessa vez.";
        this.winner = true;
        this.good = false;
      }
    },

    end() {
      this.$emit("input", 3);
    },

    updateChoice() {
      const w = this.bhash.substring(4, 5);

      if (w > 0) {
        this.choice[0] = 4; //parseInt(w) + 1
        this.choice[1] = 4; //parseInt(w) + 1
        this.choice[2] = 4; //parseInt(w) + 1
      }
    },
  },
  mounted() {
    this.choice[0] = 2;
    this.choice[1] = 4;
    this.choice[2] = 1;
  },
};
</script>

<style scoped>
.kassino {
  font-family: "Pacifico", cursive !important;
  color: yellow;
  font-weight: bolder;
  text-shadow: 1px 1px 1px rgba(150, 150, 150, 1);
}

.kassino-header {
  /* background: #ff3366; */
  width: 90%;
  margin: 0 auto;
  /* border: 5px solid #af2144; */
  border-bottom: none;
}

.kassino-footer {
  border-bottom-left-radius: 100%;
  border-bottom-right-radius: 100%;
  width: 80%;
  height: 40px;
  margin: 0 auto;
  /* border: 5px solid #af2144; */
  /* background: #ff3366; */
  border-top: none;
}

.slot-box {
  /* margin: 5px; */
  border-radius: 15px;
  /* border: 5px solid #af2144; */
  background: #ffffff;
  z-index: 100;
  /* background-image: radial-gradient(#f5f7fa 0%, #c3cfe2 100%); */
}
.slot-machine {
  border-radius: 15px;
  margin: 0 auto;
}

.slot__window {
  border: 1px solid #cecece;
  background: rgb(206, 206, 206);
  background: linear-gradient(
    0deg,
    rgba(206, 206, 206, 1) 0%,
    rgba(255, 255, 255, 1) 10%,
    rgba(255, 255, 255, 1) 90%,
    rgba(206, 206, 206, 1) 100%
  );
  border-radius: 15px;
  width: 100%;
  overflow: hidden;
}

.slot__wrap {
}

.slot__item {
  /* margin-top: 20px; */
  height: 100%;
  width: 100%;
  padding: 5px;
  text-align: center;
  color: white;

  /* line-height: 160px; */
}

.slot__item--copy {
}
</style>
